module.exports = __webpack_public_path__ + "media/night/389-1faeb26e.svg";